import Swal from 'sweetalert2'
import { IconPaths, showAlertLoading, showError } from '../../../../../../../_metronic/helpers'
import { Button } from '../../../../../../components'
import { getRelatoriosOfAtendimentosByFatura } from '../../core/_requests'
import { useFaturaAtual } from '../../core/useFaturaAtual'

/** Exporta o relatório em PDF dos atendimentos da fatura. */
export const FaturaAtendimentosListToolbar = () => {
  const { idFatura } = useFaturaAtual()

  const exportarPdf = async () => {
    // A aba abre antes da requisição (senão o navegador bloqueia como pop-up).
    const novaAba = window.open('', '_blank')
    try {
      showAlertLoading()
      const { data } = await getRelatoriosOfAtendimentosByFatura(idFatura)
      Swal.close()
      novaAba?.location.replace(data.URL)
    } catch (error) {
      novaAba?.close()
      showError(error)
    }
  }

  return (
    <Button variant='secondary-outline' icon={IconPaths.Pdf} onClick={exportarPdf}>
      Exportar PDF
    </Button>
  )
}
